import React from "react";
import {
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Chip,
} from "@mui/material";

const AttendenceReportsTable = ({ data = [], loading = false }) => {
    if (loading) {
        return (
            <Paper sx={{ p: 3, textAlign: "center" }}>
                Loading enrolled students...
            </Paper>
        );
    }

    return (
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 1000 }}>
                <TableHead>
                    <TableRow>
                        <TableCell align="center">
                            <strong>Sr. No.</strong>
                        </TableCell>

                        <TableCell align="center">
                            <strong>Member ID</strong>
                        </TableCell>

                        <TableCell align="center">
                            <strong>Member Name</strong>
                        </TableCell>

                        <TableCell align="center">
                            <strong>Mobile</strong>
                        </TableCell>

                        <TableCell align="center">
                            <strong>Activity</strong>
                        </TableCell>

                        <TableCell align="center">
                            <strong>Batch</strong>
                        </TableCell>

                        <TableCell align="center">
                            <strong>Plan</strong>
                        </TableCell>

                        <TableCell align="center">
                            <strong>Status</strong>
                        </TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                {data && data.length > 0 ? (
                    [...data]
                        .sort((a, b) => {
                            const participantA =
                                Array.isArray(a?.family_member)
                                    ? a.family_member.find((member) => member)
                                    : null;

                            const participantB =
                                Array.isArray(b?.family_member)
                                    ? b.family_member.find((member) => member)
                                    : null;

                            const nameA =
                                participantA?.name ||
                                a?.member_id?.name ||
                                "";

                            const nameB =
                                participantB?.name ||
                                b?.member_id?.name ||
                                "";

                            return nameA.localeCompare(nameB);
                        })
                        .map((row, index) => {
                            // IMPORTANT:
                            // bookingListParser converts:
                            // member_data -> member_id
                            // activity_data -> activity_id

                            const member = row?.member_id || {};

                            const secondaryMember =
                                Array.isArray(row?.family_member)
                                    ? row.family_member.find((member) => member)
                                    : null;

                            const participant = secondaryMember || member;
                            const activity = row?.activity_id || {};

                            const batch =
                                Array.isArray(row?.batch_data)
                                    ? row.batch_data[0]
                                    : row?.batch_data || {};

                            return (
                                <TableRow
                                    key={row?._id || index}
                                    hover
                                >
                                    <TableCell align="center">
                                        {index + 1}
                                    </TableCell>

                                    <TableCell align="center">
                                        {participant?.member_id || participant?.id || member?.member_id || "-"}
                                    </TableCell>

                                    <TableCell align="center">
                                        {participant?.name || member?.name || "-"}
                                    </TableCell>

                                    <TableCell align="center">
                                        {participant?.mobile || member?.mobile || "-"}
                                    </TableCell>

                                    <TableCell align="center">
                                        {activity?.name || "-"}
                                    </TableCell>

                                    <TableCell align="center">
                                        {batch?.batch_name || "-"}
                                    </TableCell>

                                    <TableCell align="center">
                                        {row?.fees_breakup?.plan_name || "-"}
                                    </TableCell>

                                    <TableCell align="center">
                                        <Chip
                                            size="small"
                                            label={
                                                row?.status
                                                    ? "Active"
                                                    : "Inactive"
                                            }
                                            color={
                                                row?.status
                                                    ? "success"
                                                    : "default"
                                            }
                                        />
                                    </TableCell>
                                </TableRow>
                            );
                        })
                    ) : (
                        <TableRow>
                            <TableCell
                                colSpan={8}
                                align="center"
                            >
                                No enrolled students found
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default AttendenceReportsTable;